import React from 'react';

export default function Modal({ title, onClose, children, footer, large }) {
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className={`modal${large ? ' modal-lg' : ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="btn btn-ghost btn-sm" onClick={onClose} style={{ fontSize: 18, padding: '4px 8px' }}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
